import { render, staticRenderFns } from "./TrialsTwo.vue?vue&type=template&id=beb79b9e&scoped=true&"
import script from "./TrialsTwo.vue?vue&type=script&lang=js&"
export * from "./TrialsTwo.vue?vue&type=script&lang=js&"
import style0 from "./TrialsTwo.vue?vue&type=style&index=0&id=beb79b9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beb79b9e",
  null
  
)

export default component.exports